/**
 * Galleries
 *
 * Add lightbox effect to WP image galleries embedded in the main content using
 * Magnific Popup. We need to use an each loop to allow multiple independent
 * galleries to appear on the same page.
 */
$(function() {
    $('.image-gallery').each(function() {
        $(this).magnificPopup({
            delegate: 'a[href$=".jpeg"], a[href$=".jpg"], a[href$=".png"]',
            type: 'image',
            gallery: {
                enabled: true
            }
        });
    });
});
